import { Modal } from '@mantine/core';

import { ReactComponent as DelectImage } from 'assets/icons/delectBlog.svg';
import PrimaryButton from 'components/primaryButton';
import SecondaryButton from 'components/secondaryButton';
import useUpdateblog from '../hooks/useUpdateblog';

const DeleteStoryModal = ({
  deleteModal,
  setDeleteModal,
  blogId,
  setBlogId,
  blogdata,
}) => {
  const updateBlog = useUpdateblog();

  // console.log('blodId', blogId);
  // console.log('blogdata', blogdata);
  return (
    <div className=''>
      <Modal
        opened={deleteModal}
        onClose={() => {
          setDeleteModal(false);
          setBlogId(null);
        }}
        title=''
        size={'40%'}
        centered
        overlayColor={'#F8F7F799'}
        overlayBlur={20}
        overlayOpacity={0.5}
        transitionDuration={100}
        overflow='inside'
        className='px-10'
        classNames={{
          title: 'text-lg font-semibold mx-auto',
          body: 'scroller h-full ',
        }}
      >
        <div className='h-[300px] flex flex-col justify-center items-center gap-y-14'>
          <h1 className='font-semibold text-normal text-center'>
            Are you sure you want to delete the story ?
          </h1>
          <DelectImage />
          <div className='flex mx-auto gap-5 b-12'>
            <button className='w-28' onClick={() => setDeleteModal(false)}>
              <SecondaryButton>No</SecondaryButton>
            </button>
            <button
              className='w-28'
              onClick={() => {
                updateBlog.mutate({
                  id: blogdata?.id ? blogdata?.id : blogId,
                  is_deleted: 'True',
                  is_draft: 'False',
                });
              }}
            >
              <PrimaryButton>Yes</PrimaryButton>
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DeleteStoryModal;
